import React from "react";

function Chat(props) {
  return <div>Chat</div>;
}

export default Chat;
